<template>
    <div >
      <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="$t('Shared.addgroupAppointment')"
        :UseScroll="true"
        :width="'60%'"
        :height="'auto'"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.TitleOK'), variant: 'primary', action: onClick },
        ]"
        @Close="close"
        >
        <GroupAppointmentAdd
            ref="GroupAppointmentAdd"
            :afterSave="afterSave">
       </GroupAppointmentAdd>

      </BaseModal>
     </div>
</template>

<script>
    import Vue from 'vue'
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import DBFunctions from '@/common/DBFunctions.js'

    import Permission from '@/common/Permission'


    export default Vue.extend({
        name: "ModalGroupAppointmentAdd",
        mixins: [ ShowMessage, DBFunctions, Permission ],

        props: {
          closeWindow: Function,
          visible: {
            type: Boolean,
            default: false
          },
        },
        data() {
            return {
                modalId: 'ModalGroupAppointmentAdd',
                emitCloseEvent: false,
            }
        },
        watch: {
          visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
          },
        },
        methods: {

            onClick() {
               this.$refs.GroupAppointmentAdd.save();
            },

            close() {
              this.emitEventCancel();
            },

            onHidden() {
                this.$emit('close');
                this.emitCloseEvent= false;
            },

            emitEventCancel() {
              this.emitCloseEvent= false;
              this.$emit('close');
            },

            afterSave() {
                this.close()
            }
        },

        async mounted () {
        },
    })
</script>
<style>

</style>
